import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon"
import Icon from "@ant-design/icons"

export const userColor = '#1890ff';
export const userBg = '#e6f7ff';
export const userBorder = '#91d5ff';
export const assistantColor = '#722ed1';
export const assistantBg = '#f9f0ff';
export const assistantBorder = '#d3adf7';

export const CustomRobotIconSvg = () => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{display: 'block'}}
    >
        {/* Antenna */}
        <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="16" cy="2" r="1.5" fill="currentColor"/>

        {/* Testa principale */}
        <rect x="8" y="6" width="16" height="12" rx="3" fill="currentColor" opacity="0.1"/>
        <rect x="8" y="6" width="16" height="12" rx="3" stroke="currentColor" strokeWidth="1.5"/>

        {/* Occhi */}
        <circle cx="12" cy="11" r="2" fill="currentColor" opacity="0.8"/>
        <circle cx="20" cy="11" r="2" fill="currentColor" opacity="0.8"/>
        <circle cx="12" cy="11" r="0.8" fill="white"/>
        <circle cx="20" cy="11" r="0.8" fill="white"/>

        {/* Bocca sorridente */}
        <path d="M13 14.5 Q16 16.5 19 14.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" fill="none"/>

        {/* Corpo */}
        <rect x="10" y="18" width="12" height="8" rx="2" fill="currentColor" opacity="0.1"/>
        <rect x="10" y="18" width="12" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/>

        {/* Pannello di controllo sul petto */}
        <rect x="13" y="20" width="6" height="3" rx="0.5" fill="currentColor" opacity="0.3"/>
        <circle cx="15" cy="21.5" r="0.5" fill="currentColor"/>
        <circle cx="17" cy="21.5" r="0.5" fill="currentColor"/>

        {/* Braccia */}
        <rect x="6" y="19" width="4" height="6" rx="2" fill="currentColor" opacity="0.1"/>
        <rect x="6" y="19" width="4" height="6" rx="2" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="22" y="19" width="4" height="6" rx="2" fill="currentColor" opacity="0.1"/>
        <rect x="22" y="19" width="4" height="6" rx="2" stroke="currentColor" strokeWidth="1.2"/>

        {/* Gambe */}
        <rect x="12" y="26" width="3" height="4" rx="1.5" fill="currentColor" opacity="0.1"/>
        <rect x="12" y="26" width="3" height="4" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
        <rect x="17" y="26" width="3" height="4" rx="1.5" fill="currentColor" opacity="0.1"/>
        <rect x="17" y="26" width="3" height="4" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
    </svg>
)

export const CustomRobotIcon = (props: Partial<CustomIconComponentProps>) => <Icon component={CustomRobotIconSvg} {...props} style={{ color: assistantColor }} />
